import { NgModule } from '@angular/core';
import {Routes, RouterModule } from '@angular/router';
import {CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule } from "@angular/forms";
import {RxViewModule } from '@rx/view';
import {RxFormsModule } from '@rx/forms';
import {RxTableModule } from "@rx/table";
import {DynamicComponentContainer } from '@rx/core';

import { OnCallOverrideListComponent } from './list/on-call-override-list.component'
import {OnCallOverrideService } from "./on-call-override.service";
import {ON_CALL_OVERRIDE_SHARED_COMPONENT_CONTAINER } from './on-call-override-shared-component.container';
@NgModule({
    imports: [
        RxViewModule, RxFormsModule,
        CommonModule, FormsModule, ReactiveFormsModule, RxTableModule
    ],
    declarations: [ OnCallOverrideListComponent, ],
    providers: [OnCallOverrideService ],
    exports: [RouterModule, OnCallOverrideListComponent, ]
})
export class OnCallOverrideSharedComponentModule { }
DynamicComponentContainer.register(ON_CALL_OVERRIDE_SHARED_COMPONENT_CONTAINER );